export const isNotEmpty = (value: any) => !!value;
